import React, { useContext } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { StoreContext } from '../../context/StoreContext';

const CartOverlayContainer = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: rgb(210, 210, 210, 0.65);
    height: 100vh;
    z-index: 5600;
    display: flex;

    button {
        flex: 1;
        background-color: transparent;
        border: none;
        padding: 0;
        background-color: transparent;
        &:active,
        &:focus {
            outline: 0;
        }
    }
`;

const CartOverlay = () => {
    const { toggleCartClose } = useContext(StoreContext);
    return (
        <CartOverlayContainer
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
                open: { opacity: 1 },
                collapsed: { opacity: 0 },
            }}
            transition={{
                duration: 0.5,
            }}
        >
            <button onClick={() => toggleCartClose()}></button>
        </CartOverlayContainer>
    );
};

export default CartOverlay;
